import { createComponent } from "@helpers/admin";
import { H1, H2, H3, H4, H5, H6 } from "@template/components";

export const Heading = createComponent({
  label: "Heading",
  component: (props) => {
    let TagComponent = () => {
      switch (props.heading) {
        case "2":
          return (
            <H2
              {...props}
              style={{
                textAlign: props.$textAlign,
                width: "100%",
              }}
            />
          );
        case "3":
          return (
            <H3
              {...props}
              style={{
                textAlign: props.$textAlign,
                width: "100%",
              }}
            />
          );
        case "4":
          return (
            <H4
              {...props}
              style={{
                textAlign: props.$textAlign,
                width: "100%",
              }}
            />
          );
        case "5":
          return (
            <H5
              {...props}
              style={{
                textAlign: props.$textAlign,
                width: "100%",
              }}
            />
          );
        case "6":
          return (
            <H6
              {...props}
              style={{
                textAlign: props.$textAlign,
                width: "100%",
              }}
            />
          );
        case "1":
        default:
          return (
            <H1
              {...props}
              style={{
                textAlign: props.$textAlign,
                width: "100%",
              }}
            />
          );
      }
    };
    return <TagComponent />;
  },
  fields: {
    children: {
      label: "Text",
      type: "textarea",
    },
    heading: {
      label: "Heading Type",
      type: "select",
      options: [
        {
          label: "Heading 1",
          value: "1",
        },
        {
          label: "Heading 2",
          value: "2",
        },
        {
          label: "Heading 3",
          value: "3",
        },
        {
          label: "Heading 4",
          value: "4",
        },
        {
          label: "Heading 5",
          value: "5",
        },
        {
          label: "Heading 6",
          value: "6",
        },
      ],
    },
    $textAlign: {
      label: "Text Align",
      type: "select",
      options: [
        {
          label: "Left",
          value: "left",
        },
        {
          label: "Center",
          value: "center",
        },
        {
          label: "Right",
          value: "right",
        },
        {
          label: "Justify",
          value: "justify",
        },
      ],
    },
  },
});
